import { OBSERVABLE_PRIVATE } from './privates';
import { OBSERVER_PRIVATE } from '../observer/privates';
export function ObservableIsFreshlyObserved(instance) {
    return instance[OBSERVABLE_PRIVATE].observers.length === 1;
}
export function ObservableIsObserved(instance) {
    return instance[OBSERVABLE_PRIVATE].observers.length > 0;
}
export function ObservableIsNotObserved(instance) {
    return instance[OBSERVABLE_PRIVATE].observers.length === 0;
}
export function LinkObservableAndObserver(instance, observer) {
    const privates = instance[OBSERVABLE_PRIVATE];
    privates.observers.push(observer);
    privates.onObserveHook(observer);
}
export function UnLinkObservableAndObserver(instance, observer) {
    const privates = instance[OBSERVABLE_PRIVATE];
    privates.observers.splice(privates.observers.indexOf(observer), 1);
    privates.onUnobserveHook(observer);
}
export function ObservableEmitAll(instance, value) {
    const observers = instance[OBSERVABLE_PRIVATE].observers.slice();
    for (let i = 0, l = observers.length; i < l; i++) {
        observers[i][OBSERVER_PRIVATE].onEmit(value, instance);
    }
}
//# sourceMappingURL=functions.js.map